"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryProductSimple = void 0;
exports.QueryProduct = QueryProduct;
const React = __importStar(require("react"));
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const GraphQLAddRemoveFields = __importStar(require("graphql-add-remove-fields"));
const Elements = __importStar(require("../elements"));
const Contexts = __importStar(require("../contexts"));
const DebugSettings = __importStar(require("../debug-settings"));
const ClientConfig = __importStar(require("../client-config"));
const GlobalActions = __importStar(require("../global-actions"));
const update_from_server_1 = require("./update-from-server");
const read_from_cache_1 = require("./read-from-cache");
const result_props_1 = require("./result-props");
function QueryProduct(props) {
    const { modalOnError = false } = props;
    return (React.createElement(ClientConfig.ClientConfigConsumer, null, config => (React.createElement(DebugSettings.DebugSettingsConsumer, null, ({ includeServerLog }) => (React.createElement(Contexts.dispatchContext.Consumer, null, dispatch => (React.createElement(Contexts.ProductEntitiesContext.Consumer, null, productEntitiesContext => (React.createElement(QueryProductInternal, Object.assign({}, props, { modalOnError: modalOnError, productEntitiesContext: productEntitiesContext, dispatch: dispatch, includeServerLog: includeServerLog, clientConfigContextValue: config })))))))))));
}
class QueryProductInternal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            query: undefined,
            variables: props.variables,
            result: {
                type: "PartialResultProps"
            }
        };
    }
    static getDerivedStateFromProps(props, state) {
        const variablesChanged = !(0, fast_deep_equal_1.default)(props.variables, state.variables);
        if (state.result.type !== "ErrorResultProps" &&
            (variablesChanged || props.query !== state.query || (0, result_props_1.isDirty)(state.result))) {
            const query = props.query;
            const variables = props.variables;
            const queryWithRequiredFields = GraphQLAddRemoveFields.addFields(query, [
                "__typename"
            ]);
            const { partial, data, stale } = (0, read_from_cache_1.readFromCache)(props.productEntitiesContext.entities, queryWithRequiredFields, variables, props.clientConfigContextValue.environment);
            const resultProps = (0, result_props_1.createResultProps)(partial, stale, data, undefined);
            const newState = {
                query,
                variables,
                result: resultProps
            };
            return newState;
        }
        return null;
    }
    componentDidMount() {
        // Didmount cannot be queried more than once per instance
        if ((0, result_props_1.isDirty)(this.state.result)) {
            this.fetchFromServer();
        }
    }
    componentDidUpdate() {
        if ((0, result_props_1.isDirty)(this.state.result)) {
            this.fetchFromServer();
        }
    }
    async fetchFromServer() {
        if (this.fetching) {
            return;
        }
        this.fetching = true;
        const { query, variables } = this.state;
        const queryWithRequiredFields = GraphQLAddRemoveFields.addFields(query, [
            "__typename"
        ]);
        const result = await (0, update_from_server_1.updateFromServer)(queryWithRequiredFields, variables, this.props.includeServerLog, this.props.clientConfigContextValue.graphqlEndpoint, this.props.clientConfigContextValue.authorization);
        switch (result.type) {
            case "UpdateFromServerResultSucess": {
                this.props.productEntitiesContext.mergeEntities(result.entities);
                break;
            }
            case "UpdateFromServerResultFailure": {
                this.setState({
                    result: {
                        type: "ErrorResultProps",
                        error: result.error
                    }
                });
                if (this.props.modalOnError) {
                    this.props.dispatch(GlobalActions.error({
                        referenceNo: "",
                        invalidState: true,
                        message: "Data fetching error",
                        exception: result.error
                    }));
                }
                break;
            }
            default: {
                (0, ts_exhaustive_check_1.exhaustiveCheck)(result);
            }
        }
        this.fetching = false;
    }
    render() {
        return this.props.children(this.state.result);
    }
}
class QueryProductSimple extends React.Component {
    render() {
        const _a = this.props, { children: childFunc } = _a, props = __rest(_a, ["children"]);
        return (React.createElement(QueryProduct, Object.assign({}, props, { modalOnError: true }), resultProps => {
            if (resultProps.type === "ErrorResultProps") {
                console.error(resultProps.error);
                return React.createElement("div", null, "Data fetching Error. See console");
            }
            if (resultProps.type === "PartialResultProps") {
                return React.createElement(Elements.Loader, null);
            }
            return childFunc(resultProps.data);
        }));
    }
}
exports.QueryProductSimple = QueryProductSimple;
//# sourceMappingURL=query-product.js.map